
import { useEffect, useState } from 'react';

import { observer } from 'mobx-react-lite';
import Stack from '@mui/joy/Stack';


import useFHRequest from 'hooks/useFHRequest';
import useWorkKey from 'hooks/useWorkKey';
import { REQUEST_STATUS } from 'utils/misc';
import WorkListItem from './WorkListItem';
import { byDate } from 'utils/sort';
import LoadingSection from './LoadingSection';

const MentorRoute = observer(() => {

    const [fetchingList, setFetchingList] = useState(false);


    const { fetchListMentor, items } = useFHRequest();

    const workKey = useWorkKey();
    const mentorRequests = items.filter((item) => item.status == REQUEST_STATUS.AWAITING_MENTOR_APPROVAL).slice().sort(byDate).reverse();

    function loadRequests() {
        if (workKey) {
            fetchListMentor(workKey).then(() => {
                setFetchingList(false);
            });
        }
    }


  useEffect(() => {
        document.title = "Mentoring";
  }, []);


    useEffect(() => {
        loadRequests();
    }, [workKey]);


    return (
        <Stack spacing={1}>
            { fetchingList && <LoadingSection /> }
                {mentorRequests.map((request) => (
                        <WorkListItem key={request.uuid} item={request} />

                ))}
        </Stack>
    );
});

export default MentorRoute;
